import { memo, useEffect, useRef } from "react";
import { useCallback } from "react";
import { useMemo } from "react";
import { useState } from "react";
import style from "./Inputs.module.css";

const InputCode = ({ label, onChange }: componentProps) => {
  const allowBackSpace = useRef<boolean>(false);

  const input0 = useRef<HTMLInputElement>(null);
  const input1 = useRef<HTMLInputElement>(null);
  const input2 = useRef<HTMLInputElement>(null);
  const input3 = useRef<HTMLInputElement>(null);
  const input4 = useRef<HTMLInputElement>(null);
  const input5 = useRef<HTMLInputElement>(null);

  const [step, setStep] = useState<number>(0);
  const [values, setValues] = useState<(number | string)[]>([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  const inputs = useMemo(
    () => [input0, input1, input2, input3, input4, input5],
    []
  );

  useEffect(() => {
    inputs[step].current?.focus();
  }, [step, inputs]);

  const onChangeHandler = useCallback(
    (e: any) => {
      allowBackSpace.current = false;
      const currentValues = [...values];
      const newSingleValue =
        /^[0-9]{1,1}$/.test(e.target.value) &&
        !e.target.value.includes("-") &&
        !e.target.value.includes(".")
          ? +e.target.value
          : "";
      setValues((values) => {
        const newValues = [...values];
        newValues[+e.target.name] = newSingleValue;
        return newValues;
      });
      currentValues[+e.target.name] = newSingleValue;
      onChange(currentValues.join(""));
      if (
        +e.target.name !== 5 &&
        /^[0-9]{1,1}$/.test(e.target.value) &&
        !e.target.value.includes("-") &&
        !e.target.value.includes(".")
      )
        setStep(+e.target.name + 1);
    },
    [onChange, values]
  );

  const onFocusHandler = useCallback(
    (e: any) => {
      if (!allowBackSpace.current) {
        let emptyIndex = -1;
        [
          values[5],
          values[4],
          values[3],
          values[2],
          values[1],
          values[0],
        ].forEach((val, index) => {
          if (!val && val !== 0) {
            emptyIndex = 5 - index;
          }
        });
        if (emptyIndex !== -1) {
          inputs?.[emptyIndex]?.current?.focus();
        } else {
          inputs?.[values.length - 1]?.current?.focus();
        }
      }
    },
    [inputs, values]
  );

  const onKeyDownHandler = useCallback(
    (e: any) => {
      if (
        e.keyCode === 8 &&
        !e.target.value &&
        e.target.value !== "0" &&
        e.target.name !== "0"
      ) {
        allowBackSpace.current = true;
        inputs[+e.target.name - 1].current?.focus();
      }
    },
    [inputs]
  );

  return (
    <div className={style.input_container}>
      {label && <label>{label}</label>}
      <div className={style.input_number}>
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input0}
          name="0"
          value={values[0]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input1}
          name="1"
          value={values[1]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input2}
          name="2"
          value={values[2]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input3}
          name="3"
          value={values[3]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input4}
          name="4"
          value={values[4]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
        <input
          className={`${style.input} ${style["input--secondary"]}`}
          type="number"
          ref={input5}
          name="5"
          value={values[5]}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onKeyDown={onKeyDownHandler}
          autoComplete="false"
        />
      </div>
    </div>
  );
};

export default memo(InputCode);

type componentProps = {
  onChange: CallableFunction;
  label?: string;
};
